import adminApi from './adminApi';

export interface TodoItem {
  id: string;
  name: string;
  description: string;
  is_complete: boolean;
}

export const todoService = {
  getTodoItems: async (): Promise<TodoItem[]> => {
    try {
      adminApi.defaults.headers.Authorization = localStorage.getItem('token');
      const response = await adminApi.get('todo-items');
      return response.data;
    } catch (error) {
      console.error('Error fetching todo items:', error);
      return [];
    }
  }
}; 